var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5039 14L11.7969 14.707L12.5039 15.414L13.2109 14.707L12.5039 14ZM13.5039 5C13.5039 4.73478 13.3985 4.48043 13.211 4.29289C13.0234 4.10536 12.7691 4 12.5039 4C12.2387 4 11.9843 4.10536 11.7968 4.29289C11.6092 4.48043 11.5039 4.73478 11.5039 5H13.5039ZM6.79688 9.707L11.7969 14.707L13.2109 13.293L8.21087 8.293L6.79688 9.707ZM13.2109 14.707L18.2109 9.707L16.7969 8.293L11.7969 13.293L13.2109 14.707ZM13.5039 14V5H11.5039V14H13.5039Z",
    fill: "#785607"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 16V17C5.5 17.5304 5.71071 18.0391 6.08579 18.4142C6.46086 18.7893 6.96957 19 7.5 19H17.5C18.0304 19 18.5391 18.7893 18.9142 18.4142C19.2893 18.0391 19.5 17.5304 19.5 17V16",
    stroke: "#785607",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportDownArrow);
export default __webpack_public_path__ + "static/media/import-down-arrow.39b49e795b64e82adf0560b4210cc7e1.svg";
export { ForwardRef as ReactComponent };